import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_TODAY_PATIENT_LIST_REQUEST,
  GET_TODAY_PATIENT_LIST_SUCCESS,
  GET_TODAY_PATIENT_LIST_FAILURE,
  GET_TODAY_PATIENT_LIST_LOADER,
} = DashboardConstants;

function* todayPatientList(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_TODAY_PATIENT_LIST_LOADER });
    const response = yield call(dashboardServices.getTodayPatientList, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_TODAY_PATIENT_LIST_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_TODAY_PATIENT_LIST_FAILURE, payload: error });
  }
}

function* todayPatientListSaga() {
  yield takeEvery(GET_TODAY_PATIENT_LIST_REQUEST, todayPatientList);
}

export default todayPatientListSaga;
